import React from 'react';
import './PrivacyPolicy.css'; // reuse the same styling

const TermsConditions = () => {
  return (
    <div className="privacy-policy-container">
      <h1>Terms &amp; Conditions</h1>
      <p className="effective-date"><strong>Effective Date:</strong> 22 July 2026</p>

      <p>
        Welcome to YogaRefer ("YogaRefer", "we", "our", or "us"). By accessing or using our
        website, creating an account, uploading content, purchasing contributor listings, or using
        any of our services, you agree to be bound by these Terms &amp; Conditions. If you do not
        agree with these Terms, please do not use our website.
      </p>

      <h2>1. About YogaRefer</h2>
      <p>
        YogaRefer is an online platform that provides educational information about yoga and
        allows registered contributors to showcase yoga photographs and profile links on selected
        yoga asana pages through paid listing plans.
      </p>

      <h2>2. Eligibility</h2>
      <p>
        You must be at least 18 years of age to create an account or purchase any service on
        YogaRefer.
      </p>
      <p>
        By registering, you confirm that all information you provide is accurate, complete, and
        up to date.
      </p>

      <h2>3. User Accounts</h2>
      <p>You are responsible for:</p>
      <ul>
        <li>Maintaining the confidentiality of your login credentials.</li>
        <li>All activities carried out through your account.</li>
        <li>Providing accurate and current information.</li>
      </ul>
      <p>YogaRefer reserves the right to suspend or terminate accounts that violate these Terms.</p>

      <h2>4. Contributor Listings</h2>
      <p>
        Registered contributors may purchase placement for their yoga photographs and profile
        links on eligible yoga asana pages.
      </p>
      <p>Contributor listings are subject to the selected subscription period.</p>
      <p>Upon expiry of the subscription:</p>
      <ul>
        <li>YogaRefer may remove the contributor's profile link, photograph, and listing without prior notice.</li>
        <li>Continued display requires renewal of the applicable subscription.</li>
        <li>YogaRefer does not guarantee permanent placement.</li>
      </ul>

      <h2>5. Payments</h2>
      <ul>
        <li>All payments are processed through authorised third-party payment providers.</li>
        <li>Prices displayed on the website are subject to change without prior notice.</li>
        <li>Unless otherwise stated, payments made for approved listings are non-refundable.</li>
        <li>YogaRefer reserves the right to refuse or cancel any order where fraudulent or suspicious activity is detected.</li>
      </ul>

      <h2>6. Contributor Content</h2>
      <p>By uploading photographs, text, or profile information, you confirm that:</p>
      <ul>
        <li>You own the content or have all necessary rights and permissions.</li>
        <li>The content does not infringe any copyright, trademark, privacy, or intellectual property rights.</li>
        <li>The content is lawful and suitable for publication.</li>
      </ul>
      <p>You remain the owner of your submitted content.</p>
      <p>
        By submitting content, you grant YogaRefer a non-exclusive, worldwide, royalty-free
        licence to display, publish, resize, optimise, and promote your content on the YogaRefer
        platform for the duration of your active listing and as reasonably necessary for platform
        operations.
      </p>

      <h2>7. Editorial Rights</h2>
      <p>YogaRefer reserves the right to:</p>
      <ul>
        <li>Review submissions before publication.</li>
        <li>Reject any submission.</li>
        <li>Edit image size or formatting.</li>
        <li>Correct minor formatting issues.</li>
        <li>Remove content that violates these Terms.</li>
        <li>Remove expired contributor listings.</li>
        <li>Suspend or terminate accounts where necessary.</li>
      </ul>

      <h2>8. Prohibited Content</h2>
      <p>Users must not upload or publish content that:</p>
      <ul>
        <li>Violates copyright or intellectual property rights.</li>
        <li>Contains misleading or false information.</li>
        <li>Promotes illegal activities.</li>
        <li>Contains obscene, offensive, hateful, or discriminatory material.</li>
        <li>Contains malware, viruses, or harmful code.</li>
        <li>Includes spam or deceptive promotional content.</li>
      </ul>

      <h2>9. Intellectual Property</h2>
      <p>
        Unless otherwise stated, the website design, branding, logos, text, graphics, and platform
        features are owned by YogaRefer and are protected by applicable intellectual property
        laws.
      </p>
      <p>
        Users may not copy, reproduce, distribute, or commercially exploit any website content
        without prior written permission.
      </p>

      <h2>10. Third-Party Links</h2>
      <p>Contributor profiles may contain links to external websites or social media profiles.</p>
      <p>
        YogaRefer is not responsible for the content, privacy practices, availability, or services
        offered by third-party websites.
      </p>

      <h2>11. Google AdSense and Advertising</h2>
      <p>YogaRefer displays advertisements provided by Google AdSense and other advertising partners.</p>
      <p>
        Advertisements displayed on the website do not constitute an endorsement, recommendation,
        or guarantee by YogaRefer.
      </p>
      <p>
        Google and its advertising partners may use cookies to personalise advertisements in
        accordance with their own privacy policies.
      </p>

      <h2>12. Search Engine and SEO Disclaimer</h2>
      <p>Contributor listings are intended to provide visibility within the YogaRefer platform.</p>
      <p>YogaRefer does not guarantee:</p>
      <ul>
        <li>Improved Google rankings.</li>
        <li>Search engine indexing.</li>
        <li>Website traffic.</li>
        <li>Business enquiries.</li>
        <li>Sales or revenue.</li>
        <li>Backlink value.</li>
      </ul>
      <p>Search engine performance depends on numerous factors beyond YogaRefer's control.</p>

      <h2>13. Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by law, YogaRefer shall not be liable for any indirect,
        incidental, consequential, or special damages arising from the use of the website,
        contributor listings, uploaded content, or third-party services.
      </p>

      <h2>14. Indemnity</h2>
      <p>
        You agree to indemnify and hold YogaRefer harmless from any claims, damages, losses,
        liabilities, or expenses arising from your uploaded content, misuse of the website, or
        breach of these Terms.
      </p>

      <h2>15. Suspension and Termination</h2>
      <p>YogaRefer may suspend or terminate any account without prior notice if:</p>
      <ul>
        <li>These Terms are violated.</li>
        <li>Payment obligations are not met.</li>
        <li>Fraudulent activity is detected.</li>
        <li>Copyright infringement occurs.</li>
        <li>Harmful or unlawful content is uploaded.</li>
      </ul>

      <h2>16. Changes to These Terms</h2>
      <p>
        YogaRefer reserves the right to modify these Terms at any time. Updated versions will be
        published on this page. Continued use of the website after changes become effective
        constitutes acceptance of the revised Terms.
      </p>

      <h2>17. Governing Law</h2>
      <p>
        These Terms shall be governed by the laws of India. Any disputes arising from these Terms
        shall be subject to the jurisdiction of the competent courts in the applicable
        jurisdiction where YogaRefer operates.
      </p>

      <h2>18. Contact Us</h2>
      <p>For any questions regarding these Terms &amp; Conditions, please contact:</p>
      <p>
        YogaRefer<br />
        Email: <a href="mailto:help.yogarefer@gmail.com">help.yogarefer@gmail.com</a><br />
        Website: <a href="https://yogarefer.com">https://yogarefer.com</a>
      </p>
    </div>
  );
};

export default TermsConditions;